import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel, UIComponentProps } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { NavigationPathViewImpl } from './navigationpathview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { NavigationPathCSSStyleImpl } from './navigationpathcss';


export interface NavigationPathComponentProps extends UIComponentProps
{
    listOfPaths: string[];
}

export interface NavigationPathComponentState extends UIComponentState
{
    listOfPaths: string[];
}

export class NavigationPathComponent extends UIComponentImpl<NavigationPathComponentProps, NavigationPathComponentState, UIDataModel> 
{
    constructor(props: NavigationPathComponentProps)
    {
        super(props);

        this.state = {listOfPaths: props.listOfPaths};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new NavigationPathViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new NavigationPathCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: NavigationPathComponentProps)
    {
        this.setState({listOfPaths: nextProps.listOfPaths});
    }

    setCurrentSelectedPath(nextPath: string)
    {
        this.state.listOfPaths.length = 0;

        let paths = nextPath.split(",");

        paths.forEach((path: string) => 
        {
            this.state.listOfPaths.push(path);
        });
        
        this.setState({listOfPaths: this.state.listOfPaths});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationpathcomponent/navigationpathcomponent.tsx